<div class="activation-link-main">
  <div class="activation-link-main__title">
    <p class="vox-heading-2" translate>sales.activation-link.title</p>
  </div>
  <hr />
  <div class="activation-link-main__container">
    <ng-container *ngIf="TABS.length > 1">
      <!-- mobile menu -->
      <div ngbDropdown class="vox-dropdown-input">
        <button ngbDropdownToggle>
          <span>
            <i *ngFor="let i of TAB_ICONS[currentTab]" [ngClass]="i"></i>
            <span
              [innerHTML]="
                'sales.activation-link.tabs.' + currentTab | translate
              "
            ></span>
          </span>
        </button>
        <div ngbDropdownMenu>
          <button
            *ngFor="let tab of TABS"
            ngbDropdownItem
            (click)="switchTab(tab)"
          >
            <i *ngFor="let i of TAB_ICONS[tab]" [ngClass]="i"></i>
            <span
              [innerHTML]="'sales.activation-link.tabs.' + tab | translate"
            ></span>
          </button>
        </div>
      </div>
      <!-- desktop menu -->
      <ul
        ngbNav
        #nav="ngbNav"
        [activeId]="currentTab"
        (navChange)="switchTab($event.nextId)"
        class="nav-pills"
        orientation="vertical"
      >
        <li *ngFor="let tab of TABS" [ngbNavItem]="tab">
          <a ngbNavLink>
            <div>
              <i *ngFor="let i of TAB_ICONS[tab]" [ngClass]="i"></i>
            </div>
            <span
              [innerHTML]="'sales.activation-link.tabs.' + tab | translate"
            ></span>
          </a>
        </li>
      </ul>
    </ng-container>

    <div class="activation-link-main__container-tab">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
